<template>
    <p class="bg-red-600 px-1 text-white" v-if="typeof value !== 'undefined'">{{value[0]}}</p>
</template>

<script>
export default {
    name: "FormError",
    props: {
        value:{
            type: Array
        },
    }
}
</script>
